import * as Cookies from 'tiny-cookie';
import jwtDecode from 'jwt-decode';
import store from '@/store';
import AuthStateEnumDeprecating from '@/core/auth-state-enum';
import {DefaultCustomer} from '@/core/customer';

// @deprecated usar @/core/auth-state-enum.
export const AuthStateEnum = AuthStateEnumDeprecating;

export default class Auth {
  static auth() {
    const accessKey = Cookies.get('access_key');
    const metadata = Cookies.get('metadata');

    let decodedMetadata = null;
    try {
      decodedMetadata = jwtDecode(metadata);
    } catch (e) {
      Auth._setAuthException('0', 'Metadata inválido');
      return;
    }

    if (!decodedMetadata) {
      Auth._setAuthException('0', 'Metadata inválido');
      return;
    }

    store.dispatch('accessKey', accessKey);
    store.dispatch('metadataCookie', metadata);

    if (Auth._isCustomer(decodedMetadata)) {
      Auth._setAuthSuccess(decodedMetadata);
    } else {
      Auth._setAuthError(decodedMetadata);
    }
  }

  static init() {
    Auth.auth();
  }

  static reinit() {
    Auth.auth();
  }

  static _isCustomer(data) {
    return data.enriched == 0 || data.enriched == 2
  }

  static _setAuthException(code = '', message = '') {
    store.dispatch('accessKey', '');
    store.dispatch('metadataCookie', '');
    store.dispatch('customer', {...DefaultCustomer});
    store.dispatch('authState', AuthStateEnum.ERROR);
    store.dispatch('authErrorCode', code);
    store.dispatch('authErrorMessage', message);
  }

  static _setAuthError(data) {
    store.dispatch('customer', data);
    store.dispatch('authState', AuthStateEnum.ERROR);
    store.dispatch('authErrorCode', data.COD_ERRO);
    store.dispatch('authErrorMessage', data.DESC_ERRO);
  }

  static _setAuthSuccess(data) {
    store.dispatch('customer', data);
    store.dispatch('authState', AuthStateEnum.AUTHENTICATED);
    store.dispatch('authErrorCode', data.COD_ERRO ? data.COD_ERRO : "");
    store.dispatch('authErrorMessage', data.DESC_ERRO ? data.DESC_ERRO : "");
  }
}
